import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HoverEffect } from '../aceternity/ui/card-hover-effect';
import Shop_Nav from './Shop_Nav';
import { fetchWishlistThunk } from '../thunks/thunks';
import empty from "../temp_assets/empty-wishlist.png";
const Wishlist = () => {
  const dispatch = useDispatch();
  const { wishlist, loading, error } = useSelector((state) => state.cart);

  useEffect(() => {
    dispatch(fetchWishlistThunk());
  }, [dispatch]);

  return (
    <div className="bg-custom-pink min-h-screen">
      <Shop_Nav />
      
      {/* Header Section */}
      <div className="text-center py-6">
        <h1 className="text-[4vw] font-bold text-gray-800">Your Wishlist</h1>
        <p className="text-lg text-[2vw] text-gray-600">Save your favorite items for later!</p>
      </div>

      {/* Wishlist Content */}
      {loading ? (
        <div className="flex justify-center items-center h-screen">
          <div className="loader border-4 border-pink-600 rounded-full w-16 h-16 border-t-transparent animate-spin"></div>
        </div>
      ) : error ? (
        <div className="flex justify-center items-center h-screen">
          <h1 className="text-3xl text-red-600">Failed to load wishlist.</h1>
        </div>
      ) : wishlist.length > 0 ? (
        <div className="py-3 px-4 lg:px-16">
          <HoverEffect items={wishlist} className="gap-6" />
        </div>
      ) : (
        <div className="flex flex-col justify-center items-center text-center">
          <img
            src={empty}
            alt="Empty Wishlist"
            className="w-1/3 mb-6"
          />
          <h1 className="text-[3vw] font-semibold text-gray-800">Your wishlist is empty!</h1>
          <p className="text-[2vw] text-lg text-gray-600">Browse our shop and add items to your wishlist.</p>
        </div>
      )}
    </div>
  );
};

export default Wishlist;
